export default "__VITE_ASSET__CSpUy9Dq__"